module.exports = __webpack_public_path__ + "static/img/partner.315a3554.png";